export interface PromptTemplate {
  id: string;
  icon: string;
  title: string;
  description: string;
  prompt: string;
  sites?: string[]; // Array of site IDs or names this template applies to
  devices?: string[]; // Array of device IDs or names this template applies to
  createdAt: string;
  updatedAt: string;
}

// Mock data for development
export const MOCK_TEMPLATES: PromptTemplate[] = [
  {
    id: '1',
    icon: 'MessageSquare',
    title: 'Intruder Alert Response',
    description: 'Standard response template for confirmed intruder alerts',
    prompt: 'You are a security monitoring agent. An intruder has been detected at {site_name}. Provide a clear, professional response to the customer explaining the situation and next steps.',
    sites: ['main-office', 'warehouse-a'],
    devices: ['front-entrance-cam', 'loading-dock-cam'],
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
  },
  {
    id: '2',
    icon: 'Shield',
    title: 'Staff Verification',
    description: 'Template for verifying staff members on site',
    prompt: 'A person has been detected at {site_name}. Please verify if this is an authorized staff member by checking their credentials and confirming their identity.',
    sites: ['main-office'],
    devices: ['reception-cam', 'elevator-cam'],
    createdAt: '2024-01-14T09:00:00Z',
    updatedAt: '2024-01-14T09:00:00Z',
  },
  {
    id: '3',
    icon: 'AlertTriangle',
    title: 'Suspicious Activity',
    description: 'Response for suspicious but unconfirmed activity',
    prompt: 'Suspicious activity has been detected at {site_name}. Describe the activity observed and recommend appropriate actions while maintaining a professional tone.',
    sites: ['parking-lot', 'perimeter'],
    devices: ['parking-cam-1', 'parking-cam-2', 'fence-line-cam'],
    createdAt: '2024-01-13T08:00:00Z',
    updatedAt: '2024-01-13T08:00:00Z',
  },
];

// Available icons for selection
export const AVAILABLE_ICONS = [
  'MessageSquare',
  'Shield',
  'AlertTriangle',
  'Bell',
  'Camera',
  'Eye',
  'Lock',
  'Unlock',
  'User',
  'Users',
  'Home',
  'Building',
  'MapPin',
  'Phone',
  'Mail',
  'FileText',
  'Clipboard',
  'CheckCircle',
  'XCircle',
  'Info',
  'HelpCircle',
  'Settings',
  'Zap',
  'Activity',
] as const;

export type AvailableIcon = typeof AVAILABLE_ICONS[number];
